/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const SET_LIST_PRODUCT = 'SET_LIST_PRODUCT';
export const SET_LIST_INVENTAIRE_HISTORY = 'SET_LIST_INVENTAIRE_HISTORY';
export const SET_INVENTAIRE_HEAD = 'SET_INVENTAIRE_HEAD';
export const SET_LIST_PRODUCT_AVERAGE_QTY = 'SET_LIST_PRODUCT_AVERAGE_QTY';

export default {
  SET_LIST_PRODUCT,
  SET_LIST_INVENTAIRE_HISTORY,
  SET_INVENTAIRE_HEAD,
  SET_LIST_PRODUCT_AVERAGE_QTY,
};
